import React from "react";
import { Link } from "react-router-dom";

// Styles
import styles from "./DashboardMain.module.css";

// Images
import ClockIcon from "./../../../assets/img/DashboardICons/ClockIcon.svg";
import arrowBlue from "./../../../assets/img/DashboardICons/ArrowLeftBlue.svg";

const DashboardMainReminders = ({ dashboardData }) => {

    return (
        <div dir="rtl" className={`mt-4 pt-3 mx-md-4 px-2`}>
            <div className={`w-100 d-flex justify-content-between`}>
                <h5 className={`${styles.total_title_dashboardMain_box}`}> یادداشت ها </h5>
                <Link to={"/my-notes"} className={`${styles.total_link_more_box}`}> مشاهده همه </Link>
            </div>

            <div className={`mt-3 d-flex justify-content-between flex-wrap`}>
                {
                    dashboardData?.map((item, i) => (
                        <div key={i} className={`p-4 mb-4 ${styles.total_reminder_box}`}>
                            <h5 className={`text-right ${styles.title_reminderInfo_box}`}> {item.title} </h5>
                            <div className={`text-right mt-3`}>
                                <img src={ClockIcon} alt="time-reminder-icon" width="17" />
                                <span className={`pe-1 ${styles.time_title_reminderInfo_box}`}> {item.createDate?.toString().replace(/\d/g, d => '۰۱۲۳۴۵۶۷۸۹'[d])} </span>
                            </div>
                            <Link to={`/note-detail/${item.id}`} className={`text-left`} style={{ color: "#21409a" }}>
                                بیشتر
                                <img className="pe-2" src={arrowBlue} alt="arrow-left-blue" width="21" />
                            </Link>
                        </div>
                    ))
                }
            </div>
        </div>
    )
}

export default DashboardMainReminders;